<template lang="pug">
div
  app-modal-visualiza-pdf(
    v-if="showModalVisualizaPdf",
    @closeModal="closeModalVisualizaPdf",
    :titulo="tituloModal",
    :tipo="tipoModal",
    :conteudo="conteudoModal",
    :isVTN="false",
    :isImagem="isImagem"
    :tituloDocumento="tituloDocumento"
  )
  app-modal-visualizar-completo(
    v-if="showModalVisualizarProcesso && informacoesSolicitacao",
    @closeModal="showModalVisualizarProcesso = false",
    :idProcesso="informacoesSolicitacao.idProcesso",
    :protocolo="informacoesSolicitacao.numeroProtocolo",
    :numeroProcesso="informacoesSolicitacao.numeroProcesso",
    :tipo="informacoesSolicitacao.tipoProcesso",
  )
  div.d-flex(v-if="informacoesSolicitacao")
    p.styleInfo Informações do processo: {{informacoesSolicitacao.numeroProcesso}}
    div.verde(
      @click="showModalVisualizarProcesso = true"
    )
      font-awesome-icon(icon="eye", size="sm")
      span &nbsp Visualizar Processo
  el-card(v-if="informacoesSolicitacao")
    app-divider.margin-bottom(:label="'Solicitação de Informações do Processo'")
    el-row.margin-top.cardSolicitacao(:gutter="30")
      el-col(:span="8")
        p <b> Setor: </b> {{ informacoesSolicitacao.setorOrigem }}
      el-col(:span="8")
        p <b> Responsável: </b> {{ informacoesSolicitacao.responsavel }}
      el-col(:span="8")
        p <b> Data de Vencimento: </b> {{ informacoesSolicitacao.dataVencimento || `&nbsp; -` }}
      el-col(:span="8")
        p <b> Assunto: </b> {{ informacoesSolicitacao.assunto }}
      el-col(:span="8")
        p <b> Data de Solicitação: </b> {{ informacoesSolicitacao.mensagemList[0].dataEnviada }}
    app-divider.margin-bottom(:label="'Solicitação:'")
    span(v-html="informacoesSolicitacao.mensagemList[0].conteudo")
    app-divider.margin-bottom(:label="'Anexos:'")
    el-table(:data="informacoesSolicitacao.mensagemList[0].anexoList", :show-header="false")
      el-table-column(
        prop="nome"
      )
      el-table-column(
        align="right"
        width="110"
      )
        template(slot-scope="scope")
          el-tooltip.btn-actions(
              effect='dark',
              :content="!isDocumentoParaVisualizacao(scope.row) ? 'Não é possível exibir esse arquivo': 'Visualizar Documento' ",
              placement="left"
            )
              el-button.button(
                v-if="scope.row && (isEstadoMA || isEstadoAP)",
                :disabled="!isDocumentoParaVisualizacao(scope.row)"
                @click="abrirDocumento(scope.row)"
              )
                font-awesome-icon(icon="eye", size="lg")
          el-tooltip.item(
            effect='dark',
            content='Baixar arquivo',
            placement="left"
          )
            el-button.button(@click="downloadAnexo(scope.row)")
              font-awesome-icon(icon="download", size="lg")
  el-card(v-if="informacoesSolicitacao && informacoesSolicitacao.status === 'RESPONDIDA'")
    el-row.margin-top(:gutter="30")
      el-col(:span="8")
        p <b> Setor: </b> {{ informacoesSolicitacao.setorRequerido }}
      el-col(:span="8")
        p <b> Data da Resposta: </b> {{ informacoesSolicitacao.mensagemList[1].dataEnviada }}
    app-divider.margin-bottom(:label="'Solicitacao Acesso:'")
    span(v-html='informacoesSolicitacao.statusSolicitacaoAcesso')
    app-divider.margin-bottom(:label="isSolicitacaoExterno? 'Justificativa:' : 'Resposta:'")
    span(v-html="informacoesSolicitacao.mensagemList[1].conteudo")
    app-divider.margin-bottom(:label="'Anexos:'")
    el-table(:data="informacoesSolicitacao.mensagemList[1].anexoList", :show-header="false")
      el-table-column(
        prop="nome"
      )
      el-table-column(
        align="right"
        width="110"
      )
        template(slot-scope="scope")
          el-tooltip.btn-actions(
              effect='dark',
              :content="!isDocumentoParaVisualizacao(scope.row) ? 'Não é possível exibir esse arquivo': 'Visualizar Documento' ",
              placement="left"
            )
              el-button.button(
                v-if="scope.row && isEstadoAP",
                :disabled="!isDocumentoParaVisualizacao(scope.row)"
                @click="abrirDocumento(scope.row)"
              )
                font-awesome-icon(icon="eye", size="lg")
          el-tooltip.item(
            effect='dark',
            content='Baixar arquivo',
            placement="left"
          )
            el-button.button(@click="downloadAnexo(scope.row)")
              font-awesome-icon(icon="download", size="lg")
  validation-observer(ref='validation' tag='form')
    el-card.margin-top(v-if="isSolicitacaoExterno && informacoesSolicitacao.status === 'PENDENTE'")
      validation-provider(:rules="!isSolicitacaoExterno ? '': 'required'", v-slot="{ errors }")
        app-divider.margin-bottom(label='Autorizar a solicitação de acesso:', required=true)
        el-radio-group.aling-center.input(v-model="permiteAcesso", :class="{'erro' : errors.length}")
          el-radio(:label="true") Autorizar
          el-radio(:label="false") Não autorizar
        span.help.erro {{ errors[0] }}
    el-card.margin-top(v-if="informacoesSolicitacao && informacoesSolicitacao.status === 'PENDENTE'")
      app-divider.margin-bottom(:label="'Responder Solicitação'"
      :required= "isEstadoMA")
      validation-provider(:rules="isSolicitacaoExterno ? '': 'required'", v-slot="{ errors }")
        el-input.input(
          :class="{'erro' : errors.length}"
          type='textarea',
          :rows='5',
          placeholder='Digite o texto...',
          v-model='respostaInformacao'
        )
        br
        span.help.erro {{ errors[0] }}
      app-divider(:label="'Anexos da mensagem'")
      app-anexo(
        :id="'upload-informacao'"
        @uploadFile="uploadFile",
        scope="anexoInformacao",
        :files="anexos",
        @removeFile="removeFile",
        @downloadDocumentoCadastro="downloadDocumentoCadastro"
        :exibirDownload="false"
      )

      app-buttons-cadastro(
        :isUltimoPasso="true",
        :isPrimeiroPasso="true",
        :showButtonSalvar="false",
        :showButtonFinalizar="false",
        :showButtonEnviar="true",
        @enviar="enviar",
        @cancelar="cancelar"
      )
</template>
<script>
import axios from '@/utils/api'
import { mapActions } from 'vuex'
import AppDivider from '@/components/AppDivider'
import FileSaver from 'file-saver'
import AppAnexo from '@/components/AppAnexo'
import AppButtonsCadastro from '@/components/AppButtonsCadastro'
import AppNotificacao from '@/components/mixins/AppNotificacao'
import AppModalVisualizarCompleto from '@/screens/analise/components/modal/AppModalVisualizarCompleto'
import AppModalVisualizaPdf from '@/screens/analise/components/AppModalVisualizaPdf'
import utils from '@/utils/utils'
const {visualizarDocumentosPDF} = require('@/utils/' + process.env.ESTADO + '/regrasAnalise').default

export default {
  components: {
    AppDivider,
    AppAnexo,
    AppButtonsCadastro,
    AppModalVisualizarCompleto,
    AppModalVisualizaPdf
  },

  mixins: [
    AppNotificacao
  ],

  props: {
    idSolicitacao: {
      type: [Number, String],
      required: true
    }
  },

  data () {
    return {
      respostaInformacao: null,
      informacoesSolicitacao: null,
      anexos: [],
      showModalVisualizarProcesso: false,
      tituloModal: null,
      tipoModal: null,
      conteudoModal: null,
      showModalVisualizaPdf: false,
      isImagem: false,
      tituloDocumento: '',
      permiteAcesso: null
    }
  },

  async created () {
    try {
      this.informacoesSolicitacao = await this.getDadosInformacaoSolicitada(this.idSolicitacao)
    } catch (e) {
      this.$router.back()
    }
  },
  computed: {
    isEstadoMA () {
      return process.env.ESTADO === 'ma'
    },
    isEstadoAP () {
      return process.env.ESTADO === 'ap'
    },
    isSolicitacaoExterno () {
      return this.informacoesSolicitacao?.setorOrigem === 'EXTERNO'
    }
  },
  methods: {
    ...mapActions({
      getDadosInformacaoSolicitada: 'informacao/getDadosInformacaoSolicitada'
    }),

    cancelar () {
      this.confirmBox(this.$messages.CANCEL_RESPOSTA_SOLICITACAO, this.$messages.TITULO_WARNING,
        () => {
          this.$router.back()
        },
        () => { })
    },

    async enviar () {
      const valido = this.$refs.validation ? await this.$refs.validation.validate() : true
      if (valido) {
        this.confirmBox(
          this.$messages.CONFIRM_RESPOSTA_SOLICITACAO,
          this.$messages.TITULO_WARNING,
          () => {
            const mensagem = {
              conteudo: this.respostaInformacao,
              anexoList: this.anexos,
              permiteAcessoProcesso: this.permiteAcesso
            }
            if (!this.isSolicitacaoExterno) {
              axios({
                method: 'POST',
                url: `solicitarInformacao/responder/${this.idSolicitacao}`,
                data: mensagem
              }).then(() => {
                this.showNotificacao(
                  this.$messages.TIPO_SUCCESS,
                  this.$messages.TITULO_SUCCESS_RESPOSTA_SOLICITACAO,
                  this.$messages.MSG_SUCESSO_RESPOSTA_SOLICITACAO
                )
                this.$router.back()
              })
            } else {
              axios({
                method: 'POST',
                url: `solicitarInformacao/responder/solicitacaoAcesso/${this.idSolicitacao}`,
                data: mensagem
              }).then(() => {
                this.showNotificacao(
                  this.$messages.TIPO_SUCCESS,
                  this.$messages.TITULO_SUCCESS_RESPOSTA_SOLICITACAO,
                  this.$messages.MSG_SUCESSO_RESPOSTA_SOLICITACAO
                )
                this.$router.back()
              })
            }
          },
          () => {}
        )
      } else {
        this.showNotificacao(
          this.$messages.TIPO_WARNING,
          this.$messages.TITULO_WARNING,
          this.$messages.ERROS_ANALISE
        )
      }
    },

    uploadFile (file) {
      this.anexos.push({
        key: file.response,
        nome: file.name,
        tipo: {
          id: 51,
          codigo: 'ANEXO_ANALISE'
        }
      })
    },

    removeFile (file) {
      this.anexos.splice(
        _.findIndex(this.anexos, anexo => anexo.key === file.key),//eslint-disable-line
        1
      )
    },

    async downloadDocumentoCadastro (file) {
      const response = await axios({
        method: 'POST',
        url: `anexoMensagem/download`,
        data: file,
        responseType: 'blob'
      })
      FileSaver.saveAs(response, response.nome)
    },

    async downloadAnexo (anexo) {
      const file = await axios({
        method: 'POST',
        url: `anexoMensagem/download`,
        data: anexo,
        responseType: 'blob'
      })
      FileSaver.saveAs(file, anexo.nome)
    },
    abrirImagem (row) {
      let extensao = utils.getExtensionFile(row.nome)
      return visualizarDocumentosPDF.extensaoImagens.includes(extensao)
    },
    isDocumentoParaVisualizacao (row) {
      let extensao = utils.getExtensionFile(row.nome)
      return visualizarDocumentosPDF.extensaoVisualizar.includes(extensao)
    },
    abrirDocumento (documento) {
      this.tipoModal = 'DOCUMENTO_MENSAGEM'
      this.tituloModal = 'Documento'
      this.conteudoModal = documento.id
      this.isImagem = this.abrirImagem(documento)
      this.showModalVisualizaPdf = true
      this.tituloDocumento = 'Documento'
    },
    closeModalVisualizaPdf () {
      this.showModalVisualizaPdf = false
    }
  }
}
</script>
<style scoped lang="scss">
.margin-bottom {
  margin-bottom: 20px;
}

.margin-top {
  margin-top: 20px;
}

.button {
  border: none;
  background: none;
  padding: 0;
}

.d-flex {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.verde {
  color: #009d64;
  cursor: pointer;
}

.verde:hover {
  color: #038d5a;
}

.aling-center {
  display: flex;
  flex-direction: row;
  justify-content: center;
  text-align: center;
}

@media (max-width: 780px) {
  .cardSolicitacao {
    display: flex;
    flex-direction: column;
    width: 740px;
  }

  .d-flex {
    flex-direction: column;
    align-items: center;
    margin-bottom: 15px;
  }
  .styleInfo {
    position: relative;
    left: 10px;
  }

}
</style>



// WEBPACK FOOTER //
// src/screens/analise/ResponderInformacoes.vue